export default __webpack_public_path__ + "static/media/c.8acad3a1c403351ee5c675a0a9f09d2c.mp3";